import {createSvgIcon} from '../create-svg-icon';

export const SignalWifi4BarIcon = createSvgIcon(
  <path d="M12.01 21.49 23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z" />
, 'SignalWifi4BarOutlined');
